import {
  Calendar,
  Landmark,
  Users,
  Wrench,
  User,
  LayoutDashboard,
  CircleDollarSign,
} from "lucide-react";
import { useLocation, useNavigate } from "react-router-dom";
import { useSocialUnreadCount } from "../hooks/useSocialUnreadCount";
import { useBankCounts } from "./bank/useBankCounts";

const navItems = [
  { name: "Dashboard", path: "/dashboard", icon: LayoutDashboard },
  { name: "Calendar", path: "/calendar", icon: Calendar },
  { name: "Bank", path: "/bank", icon: Landmark },
  { name: "Social", path: "/social", icon: Users },
  { name: "Finance", path: "/finance", icon: CircleDollarSign, disabled: true },
  { name: "Tools", path: "/tools", icon: Wrench },
  { name: "Profile", path: "/account", icon: User },
];

const SidebarNav = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { unreadCount: socialUnreadCount } = useSocialUnreadCount(true);
  const bankCounts = useBankCounts();

  const isActive = (path: string) => {
    const currentPath = location.pathname;
    if (path === "/dashboard") {
      return currentPath === "/dashboard" || currentPath === "/overview";
    }
    if (path === "/calendar") return currentPath === "/calendar";
    if (path === "/bank") return currentPath.includes("/bank");
    if (path === "/social") return currentPath.includes("/social");
    if (path === "/finance") return currentPath.includes("/finance");
    if (path === "/tools") return currentPath.includes("/tools") || currentPath.includes("/vault");
    if (path === "/account") return currentPath.includes("/account") || currentPath.includes("/modify");
    return currentPath.includes(path);
  };

  return (
    <aside
      aria-label="Sidebar"
      className="hidden h-full w-[220px] shrink-0 flex-col border-r border-border bg-white p-3 md:flex"
    >
      <nav className="flex flex-col gap-0.5" aria-label="Portal">
        {navItems.map((item) => {
          const Icon = item.icon;
          const active = isActive(item.path);
          const disabled = Boolean(item.disabled);
          return (
            <button
              key={item.path}
              type="button"
              disabled={disabled}
              onClick={() => {
                if (disabled) return;
                navigate(item.path, { state: { refresh: Date.now() } });
              }}
              className={`flex h-10 items-center gap-3 rounded-md px-3 text-[15px] font-medium transition-colors ${
                disabled
                  ? "cursor-not-allowed text-foreground/35"
                  : active
                    ? "bg-accent text-primary"
                    : "text-foreground/70 hover:bg-muted"
              }`}
            >
              <Icon className="h-[18px] w-[18px] flex-none" />
              <span className="flex-1 text-left">{item.name}</span>
              {item.name === "Social" && socialUnreadCount > 0 ? (
                <span className="min-w-[18px] rounded-full bg-primary px-1.5 text-center text-[10px] font-bold text-white">
                  {socialUnreadCount > 99 ? "99+" : socialUnreadCount}
                </span>
              ) : null}
              {item.name === "Bank" && bankCounts.totalRequests > 0 ? (
                <span className="min-w-[18px] rounded-full bg-primary px-1.5 text-center text-[10px] font-bold text-white">
                  {bankCounts.totalRequests > 99
                    ? "99+"
                    : bankCounts.totalRequests}
                </span>
              ) : null}
            </button>
          );
        })}
      </nav>
    </aside>
  );
};

export default SidebarNav;
